export default function AppPromo() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
          <div className="w-32 h-32 md:w-40 md:h-40 shrink-0 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20minimalist%20smartphone%20app%20icon%20design%20with%20warm%20crimson%20and%20amber%20gradient%2C%20magnifying%20glass%20symbol%20integrated%20with%20flame%20motif%2C%20clean%20modern%20flat%20design%20on%20subtle%20textured%20background%2C%20app%20store%20style%20presentation&width=400&height=400&seq=app-promo-qr-01&orientation=squarish"
              alt="黑料吃瓜爆料APP下载"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">随时随地，吃瓜不停</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              下载黑料吃瓜爆料 APP，第一时间接收热门爆料推送，离线也能畅快浏览。支持 iOS 和 Android 双平台，
              更有专属 APP 用户才能看到的深度独家内容。从此八卦新闻不再错过，做朋友圈里消息最灵通的吃瓜达人。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a href="#contact" className="whitespace-nowrap inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer">
                <i className="ri-apple-fill text-base"></i>App Store
              </a>
              <a href="#contact" className="whitespace-nowrap inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer">
                <i className="ri-android-fill text-base"></i>Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}